import { Box, CircularProgress, Typography } from "@mui/material";

/**
 * Suspense fallback while a lazily-imported page chunk is downloading.
 * Intentionally minimal — operators see this for ~200ms; a richer
 * per-page skeleton lives inside each page (loading=true → DataState).
 */
export default function PageSkeleton(): JSX.Element {
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={1.5} py={8}>
      <CircularProgress size={28} />
      <Typography variant="caption" color="text.secondary">
        Ачаалж байна…
      </Typography>
    </Box>
  );
}
